import { sum } from 'lodash';
import {
  MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT,
  measureNodeLabel,
} from '@ardoq/graph-labeling';
import { wrapString } from 'tabview/blocks/misc/string';
import { MODERNIZED_BLOCK_DIAGRAM_GROUP_PADDING as PADDING } from 'tabview/blockDiagram/view/yFilesExtensions/modernized/consts';
import { layoutGroupHeaderMainLabel } from './layoutGroupHeaderMainLabel';
import { MODERNIZED_BLOCK_DIAGRAM_OTHER_LABEL_PADDING as TAG_INTERIOR_PADDING } from 'yfilesExtensions/styles/modernized/consts';

type LayoutGroupHeaderLabelsArgs = {
  mainLabel: string;
  subLabel: string | null;
  otherLabels: string[] | null;
  nodeWidth: number;
  hasUrlFields: boolean;
  hasRepresentationData: boolean;
};
const layoutGroupHeaderLabels = ({
  mainLabel,
  subLabel,
  otherLabels,
  nodeWidth,
  hasUrlFields,
  hasRepresentationData,
}: LayoutGroupHeaderLabelsArgs) => {
  const availableWidth = nodeWidth - 2 * PADDING;
  // #region calculate sublabel height
  const wrappedSubLabel = subLabel
    ? wrapString(subLabel, availableWidth, measureNodeLabel, 3)
    : [];
  const subLabelHeight = wrappedSubLabel.length
    ? PADDING + wrappedSubLabel.length * LINE_HEIGHT
    : 0;
  // #endregion
  // #region calculate other labels height
  const otherLabelsAvailableWidth = availableWidth - 2 * TAG_INTERIOR_PADDING;
  const wrappedOtherLabels =
    otherLabels?.map(otherLabel =>
      wrapString(otherLabel, otherLabelsAvailableWidth, measureNodeLabel, 3)
    ) ?? [];
  const otherLabelsHeights = wrappedOtherLabels.map(
    ({ length }) => 2 * PADDING + LINE_HEIGHT * length
  );
  const otherLabelsHeight = otherLabels?.length
    ? sum(otherLabelsHeights) + PADDING * (otherLabelsHeights.length + 1)
    : 0;
  // #endregion

  return {
    ...layoutGroupHeaderMainLabel({
      mainLabel,
      nodeWidth,
      hasUrlFields,
      hasRepresentationData,
      measure: measureNodeLabel,
    }),
    wrappedSubLabel,
    subLabelHeight,
    wrappedOtherLabels,
    otherLabelsHeight,
  };
};

export { layoutGroupHeaderLabels };
